import { Button, Col, message, Row, Spin, Tabs } from 'antd';
import { Component } from 'react';
import { connect } from "react-redux";
import "../../asset/style/scanner/scanner.css";
import { AuthHeader } from "../../configs/auth.token";
import { get, post_response } from "../../helper/request";
import { setDeviceBusy, setDeviceIdle } from '../../redux_actions/device_status.action';
import {
    changeSpecimenType, dropDistanceConfirmed,
    receivedPreviewStatus,
    selectionCancelled,
    selectionConfirmed,
    selectionDone,
    setAutoThreshLevel,
    setDoTilingAfterScan,
    setDoTilingOnly,
    setDropDistancePointLength,
    setDropDistancePointOnly,
    setFocusPoints,
    setPreviewStatusToConfirmed,
    setScanName,
    setScanSpeed,
    setScanZLevels,
    setScanZStepSize, unsetDoTilingAfterScan,
    unsetDoTilingOnly,
    updateActionOngoing,
    updatePreviewStatus
} from '../../redux_actions/preview_status.action';
import { RegionSelectionConstants } from "../../redux_constants/region_selection.constant";
import { ScanApiConstant } from '../../redux_constants/scan.constant';
import { getGlobalConfig } from "../../utils/api";
import {
    antdSpinLoaderSmallIcon,
    brushShape, brushType, circleBrushSize, scanSettingsTypeVals,
    scanSpeed,
    scanWorkflowLoadingMessages, SlotRegionSelectionConstants, specimenType
} from "../../utils/const";
import { getKeyByValue, isTrue } from "../../utils/utils";
import { getAreaFromBoundingBox } from "./preview_utils";
import AdvancedPreviewSettingsComp from './scanWorkflow/advancedPreviewSettingsComponent';
import GeneralPreviewSettingsComp from './scanWorkflow/generalPreviewSettingsComponent';
import {
    boundRegions, cleanThresholdBorder, cleanUpExtra, createBorderOnThresholdedCanvas, drawCrossHairInitial, prepareThresholdImageForSave, updateImages
} from "./slot_component_utils";

const {TabPane} = Tabs;

const initState = (id, previewStatus, initRegions) => ({
    regions: initRegions,
    selectedSlot: id,
    previewStatus: previewStatus,
    usingBrush: true,
    brushType: brushType.REDRAW,
	regionArea: 0,
	brushSize: 15,
	reading_barcode: false,
	scanSettingsType: scanSettingsTypeVals.GENERAL,
	scanPathSet: false,
	currResponse: {},
	cacheBusterTime: (new Date()).getTime(),
	scanForThresholding: false,
	scanBlurForThresholding: false,
    autoExport: false,
    brushShape: brushShape.SQUARE,
})

class SlotComponent extends Component {

	constructor(props) {
		super(props);
		let region = this.props.defaultConfig.defaultGreenBox == undefined ? undefined : [this.props.defaultConfig.defaultGreenBox];
		if (region == undefined){
		region = [{
			height: 90,
			width: 67,
			x: 30,
			y: 5,
			}];
		}
		region[0]['data'] = {index: 0}
		this.state = initState(this.props.id, undefined, region);
		this.paint = false;

        getGlobalConfig().then(res => {
            this.setState({
                autoExport: isTrue(res.data['auto_export_enabled']),
            })
        })
	}

	scanForThresholdingChange = (value) => {
        this.setState({
            scanForThresholding: value
        });
	}

	scanBlurForThresholdingChange = (value) => {
		this.setState({
            scanBlurForThresholding: value
        });
	}

    setAdvancedModeConfigs = () => {
        let partsOfUrl = "api~scan~set_advance_mode_configs/"
        let url = `/server/scano/` + this.props.device_id + `/` + partsOfUrl + "?slot_id=" + this.props.id + "&threshold_scan=" + (this.state.scanForThresholding) + 
        "&blur_for_threshold=" + (this.state.scanBlurForThresholding) + "&auto_export=" + (this.state.autoExport);
        get(url, {headers: {Authorization: AuthHeader()}})
            .then(response => {
            }
            )
            .catch(error => {
                console.error(error)
            })
    }

    updateArea = (regionArea) => {
        this.setState({
            regionArea
        });
    }

	onCanvasUpdate = (regions) => {
		this.setState({
			regions: boundRegions(regions, false),
		});
		let slot_status = (((this.props.deviceStatus[this.props.device_id] || {}).scanner_health || {}).scanner_response|| {}).scanPreviewStatus[this.props.id]
		let previewHeight = ((slot_status||{}).previewResponse||{}).previewHeight
		let previewWidth = ((slot_status||{}).previewResponse||{}).previewWidth
		getAreaFromBoundingBox(regions[0], previewHeight, previewWidth, this.state.selectedSlot, this.props.device_id, this.updateArea);
	}

    cleanupExtraCallback = () => {
        cleanUpExtra(this.thresholdCanvas, this.thresholdCanvas?.getContext('2d'), this.state.regions[0]);
    }

    componentDidMount = () => {
        let newStatus = (this.props.preview || {}).status;
        if (this.state.selectedSlot !== this.props.id) {
            if (newStatus === RegionSelectionConstants.SELECTION_DONE) {
                this.props.dispatch(selectionCancelled(this.props.id));
            }
            let newRegions = newStatus === RegionSelectionConstants.CONFIRMED ? [this.props.preview.region] : undefined;
            this.setState(Object.assign({}, this.state, initState(this.props.id, undefined, newRegions)));
        } else if (this.state.previewStatus !== newStatus && this.previewCanvas != null) {
            if (newStatus === RegionSelectionConstants.FETCHED_IMAGE ||
                newStatus === RegionSelectionConstants.SELECTION_DONE ||
                newStatus === RegionSelectionConstants.CONFIRMED) {
                let cache_buster_time = this.state.cacheBusterTime;
                let defaultMaskLocation = this.props.preview.response.defaultMaskLocation + "?d=" + cache_buster_time;
                if ((this.props.preview || {}).specimenType == specimenType.HNE_TISSUE) {
                    defaultMaskLocation = this.props.preview.response.defaultHneMaskLocation + "?d=" + cache_buster_time;
                } else if ((this.props.preview || {}).specimenType == specimenType.IHC) {
                    defaultMaskLocation = this.props.preview.response.defaultIhcMaskLocation + "?d=" + cache_buster_time;
                } else if ((this.props.preview || {}).specimenType == specimenType.PAP) {
                    defaultMaskLocation = this.props.preview.response.defaultPapMaskLocation + "?d=" + cache_buster_time;
                } else if ((this.props.preview || {}).specimenType == specimenType.BM) {
                    defaultMaskLocation = this.props.preview.response.defaultBmMaskLocation + "?d=" + cache_buster_time;
                } else if ((this.props.preview || {}).specimenType == specimenType.BLOOD) {
                    defaultMaskLocation = this.props.preview.response.defaultBloodMaskLocation + "?d=" + cache_buster_time;
                }

                let autoPreviewThreshold = (((this.props.deviceStatus[this.props.device_id] || {}).scanner_health || {}).scanner_response|| {}).autoPreviewThreshold;
                if (autoPreviewThreshold === true) {
                    // use good default mask location
                    let goodDefaultIndex = this.props.preview.response.threshLevelResult.goodDefaultIndex;
                    defaultMaskLocation = this.props.preview.response.autoThreshMaskLocations[goodDefaultIndex] + "?d=" + cache_buster_time;
                    
                    this.props.dispatch(setAutoThreshLevel(this.props.id, goodDefaultIndex));
                }

                updateImages(this.previewCanvas, this.props.preview.response.uploadLocation + "?d=" + cache_buster_time,
                    this.thresholdCanvas, defaultMaskLocation, this.state.regions, this.cleanupExtraCallback);
            }
            this.setState(Object.assign({}, this.state, {previewStatus: newStatus}));
        }
        this.selectFullRegion();
        this.onCanvasUpdate(this.state.regions);
    }

    componentDidUpdate(prevProps, prevState) {
        this.updatePreviewBox(prevState);

        if (prevProps.preview.status != this.props.preview.status && this.props.preview.status == RegionSelectionConstants.FETCHED_IMAGE) {
            this.selectFullRegion();
        }

        if (prevProps.preview.status != this.props.preview.status && this.props.preview.status == RegionSelectionConstants.START_DROP_DISTANCE_SELECTION) {
            if (this.props.preview.dropDistancePoint != undefined) {
                drawCrossHairInitial(this.props.preview.dropDistancePoint[0].x, this.props.preview.dropDistancePoint[0].y, this.dropDistanceCanvas,
                    {clearCanvas: true, color: 'red', size: 10, width: 1}, this.props.preview);
            }
        }

        if (prevProps.preview.status != this.props.preview.status && this.props.preview.status == RegionSelectionConstants.START_FOCUS_POINTS_SELECTION) {
            let pointDrawn = false;
            for (let island in this.props.preview.focusPoints) {
                for (let i = 0; i < this.props.preview.focusPoints[island].length; i++) {
                    let focusUnit = this.props.preview.focusPoints[island][i];
                    if (focusUnit.length > 0) {
                        drawCrossHairInitial(focusUnit[0].x, focusUnit[0].y, this.focusPointsCanvas,
                            {clearCanvas: !pointDrawn, color: 'green', size: 5, width: 1}, this.props.preview);
                        pointDrawn = true;
                    }
                }
            }
        }
    }

    updatePreviewBox = (prevState) => {
        let newStatus = (this.props.preview || {}).status;
        if (this.state.selectedSlot !== this.props.id) {
            if (newStatus === RegionSelectionConstants.SELECTION_DONE) {
                this.props.dispatch(selectionCancelled(this.props.id));
            }
            let newRegions = newStatus === RegionSelectionConstants.CONFIRMED ? [this.props.preview.region] : undefined;
            this.setState(Object.assign({}, this.state, initState(this.props.id, undefined, newRegions)));
        } else if ((this.state.previewStatus !== newStatus ||
            (this.state.brushType !== prevState.brushType &&
                !(prevState.brushType == brushType.BRUSH && this.state.brushType == brushType.ERASER) &&
                !(prevState.brushType == brushType.ERASER && this.state.brushType == brushType.BRUSH)) ||
            this.state.regions !== prevState.regions) && this.previewCanvas != null) {
            if (newStatus === RegionSelectionConstants.FETCHED_IMAGE ||
                newStatus === RegionSelectionConstants.SELECTION_DONE ||
                newStatus === RegionSelectionConstants.CONFIRMED) {
                let date = new Date();
                let cache_buster_time = this.state.cacheBusterTime;
                let defaultMaskLocation = this.props.preview.response.defaultMaskLocation + "?d=" + cache_buster_time;
                if ((this.props.preview || {}).specimenType == specimenType.HNE_TISSUE) {
                    defaultMaskLocation = this.props.preview.response.defaultHneMaskLocation + "?d=" + cache_buster_time;
                } else if ((this.props.preview || {}).specimenType == specimenType.IHC) {
                    defaultMaskLocation = this.props.preview.response.defaultIhcMaskLocation + "?d=" + cache_buster_time;
                } else if ((this.props.preview || {}).specimenType == specimenType.PAP) {
                    defaultMaskLocation = this.props.preview.response.defaultPapMaskLocation + "?d=" + cache_buster_time;
                } else if ((this.props.preview || {}).specimenType == specimenType.BM) {
                    defaultMaskLocation = this.props.preview.response.defaultBmMaskLocation + "?d=" + cache_buster_time;
                } else if ((this.props.preview || {}).specimenType == specimenType.BLOOD) {
                    defaultMaskLocation = this.props.preview.response.defaultBloodMaskLocation + "?d=" + cache_buster_time;
                }
                
                let autoPreviewThreshold = (((this.props.deviceStatus[this.props.device_id] || {}).scanner_health || {}).scanner_response|| {}).autoPreviewThreshold;
                if (autoPreviewThreshold) {
                    // use auto thresh mask location for the slider value
                    defaultMaskLocation = this.props.preview.response.autoThreshMaskLocations[this.props.preview.autoThresholdLevel] + "?d=" + cache_buster_time;
                }

                this.setState({
                    scanPathSet: false,
                });
                updateImages(this.previewCanvas, this.props.preview.response.uploadLocation + "?d=" + cache_buster_time,
                    this.thresholdCanvas, defaultMaskLocation, this.state.regions, this.cleanupExtraCallback);
            }
            this.setState({
                previewStatus: newStatus,
            });
            // this.setState(Object.assign({}, this.state, {previewStatus : newStatus}));
        }
    }

    confirmClicked = () => {
        if (this.props.preview.status === RegionSelectionConstants.FETCHED_IMAGE) {
            this.props.dispatch(selectionDone(this.props.id));
        } else if (this.props.preview.status === RegionSelectionConstants.SELECTION_DONE) {
            prepareThresholdImageForSave(this.thresholdCanvas)
            let imageURLData = this.thresholdCanvas.toDataURL("image/jpeg");
            let reg = this.state.regions[0];
            let x1 = parseInt((reg.x * this.props.preview.response.previewWidth) / 100.0);
            let x2 = parseInt(((reg.x + reg.width) * this.props.preview.response.previewWidth) / 100.0);
            let y1 = parseInt((reg.y * this.props.preview.response.previewHeight) / 100.0);
            let y2 = parseInt(((reg.y + reg.height) * this.props.preview.response.previewHeight) / 100.0);
            let actualReg = [x1, y1, x2, y2]
            let thresholdCanvas = this.thresholdCanvas;
            let x1_box = parseInt((reg.x * thresholdCanvas.width) / 100.0);
            let x2_box = parseInt(((reg.x + reg.width) * thresholdCanvas.width) / 100.0);
            let y1_box = parseInt((reg.y * thresholdCanvas.height) / 100.0);
            let y2_box = parseInt(((reg.y + reg.height) * thresholdCanvas.height) / 100.0);
            let green_box_region = [x1_box, y1_box, x2_box, y2_box];

            this.props.dispatch(selectionConfirmed(this.props.device_id, this.props.id, reg, actualReg,
                imageURLData, this.props.preview.slideName, this.props.startScanning, this.props.cassetteSize, this.props.preview.specimenType,
                this.props.preview.objectiveType, this.props.preview, this.dropDistanceCanvas, green_box_region));
        } else if (this.props.preview.status === RegionSelectionConstants.START_DROP_DISTANCE_SELECTION) {
            this.props.dispatch(dropDistanceConfirmed(this.props.device_id, this.props.id, this.props.preview, this.focusPointsCanvas));
        } else if (this.props.preview.status === RegionSelectionConstants.START_FOCUS_POINTS_SELECTION) {
            this.props.dispatch(updatePreviewStatus(this.props.id, RegionSelectionConstants.CONFIRMED));
        }
    }

    confirmPreviewSettingChanges = () => {
        this.setAdvancedModeConfigs();
        // if (!this.state.scanPathSet) {
            prepareThresholdImageForSave(this.thresholdCanvas)
            let imageURLData = this.thresholdCanvas.toDataURL("image/jpeg");
            console.log("image url:", imageURLData)
            let reg = this.state.regions[0];
            let x1 = parseInt((reg.x * this.props.preview.response.previewWidth) / 100.0);
            let x2 = parseInt(((reg.x + reg.width) * this.props.preview.response.previewWidth) / 100.0);
            let y1 = parseInt((reg.y * this.props.preview.response.previewHeight) / 100.0);
            let y2 = parseInt(((reg.y + reg.height) * this.props.preview.response.previewHeight) / 100.0);
            let actualReg = [x1, y1, x2, y2];
            let thresholdCanvas = this.thresholdCanvas;
            let x1_box = parseInt((reg.x * thresholdCanvas.width) / 100.0);
            let x2_box = parseInt(((reg.x + reg.width) * thresholdCanvas.width) / 100.0);
            let y1_box = parseInt((reg.y * thresholdCanvas.height) / 100.0);
            let y2_box = parseInt(((reg.y + reg.height) * thresholdCanvas.height) / 100.0);
            let green_box_region = [x1_box, y1_box, x2_box, y2_box];
            this.props.dispatch(setDeviceBusy(this.props.device_id));
            this.props.dispatch(updateActionOngoing(this.props.id, true, scanWorkflowLoadingMessages.CALCULATE_FOCUS_POINTS));
            const url = '/server/devices/' + this.props.device_id + "/send_threshold_image/?slot_id=" + this.props.id+"&recalculate_path="+(!this.state.scanPathSet);
            const data = {
                imgBase64: imageURLData,
                specimenType: getKeyByValue(specimenType, this.props.preview.specimenType),
                objectiveType: this.props.preview.objectiveType,
                actualRegion: actualReg,
                previewData: this.props.preview,
                greenBoxRegion: green_box_region,
            }
            post_response(url, data)
                .then(response => {
                    if (response.status === 200) {
                        this.props.dispatch(setPreviewStatusToConfirmed(this.props.id, reg, actualReg));
                        this.props.dispatch(setDropDistancePointOnly(this.props.id, response.data.dropDistancePoint));
                        this.props.dispatch(setDropDistancePointLength(this.props.id, response.data.dropDistancePoint));
                        this.props.dispatch(setFocusPoints(this.props.id, response.data.focusPoints));
                        this.props.dispatch(updatePreviewStatus(this.props.id, RegionSelectionConstants.CONFIRMED));
                        this.setState({
                            scanPathSet: true,
                            currResponse: response,
                        });

                    } else {
                        this.props.dispatch(receivedPreviewStatus(ScanApiConstant.ERRORED_WHILE_CONFIRMING_SELECTION, response, this.props.id))
                        message.error("Not able to confirm preview settings. Please contact admin.", 2.5);
                    }
                    this.props.dispatch(setDeviceIdle(this.props.device_id));
                    this.props.dispatch(updateActionOngoing(this.props.id, false, scanWorkflowLoadingMessages.EMPTY_MESSAGE));
                })
                .then(response => {
                        this.props.closeExpadedSlideView();
                    }
                )
                .catch(err => {
                    this.props.dispatch(receivedPreviewStatus(ScanApiConstant.ERRORED_WHILE_CONFIRMING_SELECTION, err, this.props.id))
                    this.props.dispatch(setDeviceIdle(this.props.device_id));
                    this.props.dispatch(updateActionOngoing(this.props.id, false, scanWorkflowLoadingMessages.EMPTY_MESSAGE));
                    message.error("Not able to confirm preview settings. Please contact admin.", 2.5);
                })

        // } else {
        //     this.props.dispatch(updatePreviewStatus(this.props.id, RegionSelectionConstants.CONFIRMED));
        //     this.props.closeExpadedSlideView();
        // }
    }

    paintCell = (x, y) => {
        const thresholdContext = this.thresholdCanvas.getContext('2d');
        if (this.state.brushShape === brushShape.SQUARE) {
            var cellWidth = (parseInt(this.state.brushSize / 2)) * 2;
            thresholdContext.clearRect(x - cellWidth / 2, y - cellWidth / 2, cellWidth, cellWidth);
            thresholdContext.fillStyle = this.state.brushType === brushType.BRUSH ? SlotRegionSelectionConstants.SELETION_FILL.RGBA : SlotRegionSelectionConstants.BLANK.RGBA;
            thresholdContext.fillRect(x - cellWidth / 2, y - cellWidth / 2, cellWidth, cellWidth);
            var img = thresholdContext.getImageData(0, 0, this.thresholdCanvas.width, this.thresholdCanvas.height);

            let affectedRegion = {startX:x - cellWidth/2, startY:y - cellWidth/2, endX: x + cellWidth/2, endY: y + cellWidth/2};
            img = cleanThresholdBorder(img, affectedRegion.startX, affectedRegion.startY, affectedRegion.endX, affectedRegion.endY);
            img = createBorderOnThresholdedCanvas(img, affectedRegion.startX-1, affectedRegion.startY-1, affectedRegion.endX+1, affectedRegion.endY+1);
            thresholdContext.putImageData(img,0,0);
        } else {
            const cellRadius = circleBrushSize[this.state.brushShape];

            thresholdContext.globalCompositeOperation = this.state.brushType === brushType.BRUSH ? 'xor' : 'source-over';
            thresholdContext.fillStyle = this.state.brushType === brushType.BRUSH ? SlotRegionSelectionConstants.SELETION_FILL.RGBA : SlotRegionSelectionConstants.BLANK.RGBA;
            if (this.state.brushType === brushType.BRUSH) {
                thresholdContext.beginPath();
                thresholdContext.arc(x, y, cellRadius , 0, 2 * Math.PI);
                thresholdContext.fill();
                thresholdContext.closePath();
            }

            var img = thresholdContext.getImageData(0, 0, this.thresholdCanvas.width, this.thresholdCanvas.height);

            let affectedRegion = {startX: x - cellRadius, startY: y - cellRadius, endX: x + cellRadius, endY: y + cellRadius};
            // img = cleanThresholdBorder(img, affectedRegion.startX, affectedRegion.startY, affectedRegion.endX, affectedRegion.endY);
            img = createBorderOnThresholdedCanvas(img, affectedRegion.startX - 1, affectedRegion.startY - 1, affectedRegion.endX + 1, affectedRegion.endY + 1);
            thresholdContext.putImageData(img, 0, 0);
        }

    }

    showBrushOrEraserSize = (event) => {
        const cnvs = this.brushEraserPrevCanvas;
        if (cnvs != null) {
            const cnvsCtx = cnvs.getContext('2d');
            cnvsCtx.clearRect(0, 0, cnvs.width, cnvs.height);
            var rect = cnvs.getBoundingClientRect();
            var canvasx = rect.x;
            var canvasy = rect.y;
            var mousex = parseInt(((event.pageX - canvasx) / rect.width) * cnvs.width);
            var mousey = parseInt(((event.pageY - canvasy) / rect.height) * cnvs.height);
            if (this.state.brushShape === brushShape.SQUARE) {
                var cellWidth = (parseInt(this.state.brushSize / 2)) * 2;
                cnvsCtx.clearRect(mousex - cellWidth / 2, mousey - cellWidth / 2, cellWidth, cellWidth);
                cnvsCtx.fillStyle = this.state.brushType === brushType.BRUSH ? "rgba(20,200,20,0.15)" : "rgba(200,20,20,0.15)";
                cnvsCtx.fillRect(mousex - cellWidth / 2, mousey - cellWidth / 2, cellWidth, cellWidth);
                cnvsCtx.lineWidth = 1;
                cnvsCtx.strokeStyle = this.state.brushType === brushType.BRUSH ? "#22ee22" : "#EE2222";
                cnvsCtx.strokeRect(mousex - cellWidth / 2, mousey - cellWidth / 2, cellWidth, cellWidth);
            } else {
                var cellRadius = circleBrushSize[this.state.brushShape];
                cnvsCtx.clearRect(mousex - cellRadius, mousey - cellRadius, cellRadius * 2, cellRadius * 2);
                cnvsCtx.fillStyle = this.state.brushType === brushType.BRUSH ? "rgba(20,200,20,0.15)" : "rgba(200,20,20,0.15)";
                cnvsCtx.beginPath();
                cnvsCtx.arc(mousex, mousey, cellRadius, 0, 2 * Math.PI);
                cnvsCtx.fill();
                cnvsCtx.lineWidth = 1;
                cnvsCtx.strokeStyle = this.state.brushType === brushType.BRUSH ? "#22ee22" : "#EE2222";
                cnvsCtx.stroke();
            }

        } else {
            console.warn("brush eraser preview canvas is null");
        }
    }

    paintCanvas = (event) => {
        if (this.paint) {
            var rect = this.thresholdCanvas.getBoundingClientRect();
            var canvasx = rect.x;
            var canvasy = rect.y;
            var mousex = parseInt(((event.pageX - canvasx) / rect.width) * this.thresholdCanvas.width);
            var mousey = parseInt(((event.pageY - canvasy) / rect.height) * this.thresholdCanvas.height);
            this.paintCell(mousex, mousey);

            // Clear any painting outside the region box
            cleanUpExtra(this.thresholdCanvas, this.thresholdCanvas?.getContext('2d'), this.state.regions[0]);
        }
        // show preview of current brush or eraser size
        this.showBrushOrEraserSize(event);
    }

    startPainting = (event) => {
        this.paint = true;
        this.paintCanvas(event);
        if (this.state.scanPathSet) {
            this.setState({
                scanPathSet: false,
            });
        }
    }

    stopPainting = () => {
        // make text selectable again
		document.body.classList.remove('unselectable');
        this.paint = false;
    }

    selectFullRegion = () => {
        this.setState(Object.assign({}, this.state, {
            regions: [
                {
                    data: {index: 0},
                    height: 100,
                    isChanging: false,
                    new: false,
                    width: 100,
                    x: 0,
                    y: 0,
                }
            ],
            oldState: RegionSelectionConstants.SELECTION_DONE
        }));
        this.confirmClicked();
    }

    toggleTiling = (event) => {
        if (event.target.checked) {
            this.props.dispatch(setDoTilingOnly(this.props.id));
        } else {
            this.props.dispatch(unsetDoTilingOnly(this.props.id));
        }
    }

    toggleTilingAfterScan = (event) => {
        if (event.target.checked) {
            this.props.dispatch(setDoTilingAfterScan(this.props.id));
        } else {
            this.props.dispatch(unsetDoTilingAfterScan(this.props.id));
        }
    }

    readbarcode = () => {
        this.setState({
            reading_barcode: true
        });
        let previewPath = this.props.preview.response.barcodeLocation;
        let url = `/server/devices/${this.props.device_id}/read_barcode/?path=${previewPath}`;
        get(url).then(data => {
            if (data === "") {
                message.warn("No Barcode found on Slide. Please write Slide Name.")
            } else {
                this.props.dispatch(setScanName(this.props.id, data))
            }
            this.setState({
                reading_barcode: false
            });
        })
            .catch(err => {
                console.log(err);
            });
    }
	toggleExporting = (event) => {
		this.setState({autoExport: event.target.checked})
	}

	toggleTilingAfterScan = (event) => {
		if (event.target.checked) {
			this.props.dispatch(setDoTilingAfterScan(this.props.id));
		} else {
			this.props.dispatch(unsetDoTilingAfterScan(this.props.id));
		}
	}

    movedBrushSizeSlider = (value) => this.setState({brushSize: value});

    changeBrushType = (e) => {
        if (e.target.value === brushType.REDRAW) {
            this.setState({
                scanPathSet: false,
            });
        }
        if (e.target.value === brushType.ERASER && this.state.brushShape !== brushShape.SQUARE) {
            this.setState({
                brushShape: brushShape.SQUARE,
            });
        }
        this.setState({
            brushType: e.target.value,
        });
    }

    changeBrushShape = (brushShape) => {
        this.setState({
            brushShape: brushShape,
        });
    }

    previewCanvasRef = previewCanvas => this.previewCanvas = previewCanvas;

    thresholdCanvasRef = thresholdCanvas => this.thresholdCanvas = thresholdCanvas;

    brushEraserPrevCanvasRef = brushEraserPrevCanvas => this.brushEraserPrevCanvas = brushEraserPrevCanvas;

    dropDistanceCanvasRef = dropDistanceCanvas => this.dropDistanceCanvas = dropDistanceCanvas;

    focusPointsCanvasRef = focusPointsCanvas => this.focusPointsCanvas = focusPointsCanvas;

    onScanSpeedChange = (event) => {
        this.props.dispatch(setScanSpeed(this.props.id, event.target.value));
    }

    onScanSpeedChangeStack = () => {
        this.props.dispatch(setScanSpeed(this.props.id, scanSpeed.ZSTACK));
    }

    onZLevelsChange = (event) => this.props.dispatch(setScanZLevels(this.props.id, event.target.value));

    onStepSizeChange = (event) => this.props.dispatch(setScanZStepSize(this.props.id, event.target.value));

    onSpecimenTypeChange = (event) => {
        this.props.dispatch(changeSpecimenType(this.props.device_id, this.props.id, event.target.value));

        let date = new Date();
        let cache_buster_time = this.state.cacheBusterTime;
        let defaultMaskLocation = this.props.preview.response.defaultMaskLocation + "?d=" + cache_buster_time;
        if (event.target.value == specimenType.HNE_TISSUE) {
            defaultMaskLocation = this.props.preview.response.defaultHneMaskLocation + "?d=" + cache_buster_time;
        } else if (event.target.value == specimenType.IHC) {
            defaultMaskLocation = this.props.preview.response.defaultIhcMaskLocation + "?d=" + cache_buster_time;
        } else if (event.target.value == specimenType.PAP) {
            defaultMaskLocation = this.props.preview.response.defaultPapMaskLocation + "?d=" + cache_buster_time;
        } else if (event.target.value == specimenType.BM) {
            defaultMaskLocation = this.props.preview.response.defaultBmMaskLocation + "?d=" + cache_buster_time;
        } else if (event.target.value == specimenType.BLOOD) {
            defaultMaskLocation = this.props.preview.response.defaultBloodMaskLocation + "?d=" + cache_buster_time;
        }
        updateImages(this.previewCanvas, this.props.preview.response.uploadLocation + "?d=" + cache_buster_time,
            this.thresholdCanvas, defaultMaskLocation, this.state.regions, this.cleanupExtraCallback);

        this.setState({
            scanPathSet: false,
        });
    }

    onAutoThreshLevelChange = (value) => {
		this.props.dispatch(setAutoThreshLevel(this.props.id, value));

		let cache_buster_time = this.state.cacheBusterTime;
		let defaultMaskLocation = this.props.preview.response.autoThreshMaskLocations[value] + "?d=" +  cache_buster_time;
		updateImages(this.previewCanvas, this.props.preview.response.uploadLocation + "?d=" + cache_buster_time,
			this.thresholdCanvas, defaultMaskLocation, this.state.regions, this.cleanupExtraCallback);
		
		this.setState({
			scanPathSet: false,
		});
	}

    onScanNameChange = (event) => {
        let slide_name = event.target.value;
        this.props.dispatch(setScanName(this.props.id, slide_name))
    }

    changeScanSettingsType = (key) => {
        if (key == scanSettingsTypeVals.ADVANCED) {
            if (!this.state.scanPathSet) {
                let imageURLData = this.thresholdCanvas.toDataURL("image/jpeg");
                let reg = this.state.regions[0];
                let x1 = parseInt((reg.x * this.props.preview.response.previewWidth) / 100.0);
                let x2 = parseInt(((reg.x + reg.width) * this.props.preview.response.previewWidth) / 100.0);
                let y1 = parseInt((reg.y * this.props.preview.response.previewHeight) / 100.0);
                let y2 = parseInt(((reg.y + reg.height) * this.props.preview.response.previewHeight) / 100.0);
                let actualReg = [x1, y1, x2, y2];
                let thresholdCanvas = this.thresholdCanvas;
                let x1_box = parseInt((reg.x * thresholdCanvas.width) / 100.0);
                let x2_box = parseInt(((reg.x + reg.width) * thresholdCanvas.width) / 100.0);
                let y1_box = parseInt((reg.y * thresholdCanvas.height) / 100.0);
                let y2_box = parseInt(((reg.y + reg.height) * thresholdCanvas.height) / 100.0);
                let green_box_region = [x1_box, y1_box, x2_box, y2_box];
                this.props.dispatch(setDeviceBusy(this.props.device_id));
                this.props.dispatch(updateActionOngoing(this.props.id, true, scanWorkflowLoadingMessages.CALCULATE_FOCUS_POINTS));
                const url = '/server/devices/' + this.props.device_id + "/send_threshold_image/?slot_id=" + this.props.id;
                const data = {
                    imgBase64: imageURLData,
                    specimenType: this.props.preview.specimenType,
                    objectiveType: this.props.preview.objectiveType,
                    actualRegion: actualReg,
                    previewData: this.props.preview,
                    greenBoxRegion: green_box_region,
                }
                post_response(url, data)
                    .then(response => {
                        if (response.status === 200) {
                            this.props.dispatch(setPreviewStatusToConfirmed(this.props.id, reg, actualReg));
                            this.props.dispatch(setDropDistancePointOnly(this.props.id, response.data.dropDistancePoint));
                            this.props.dispatch(setDropDistancePointLength(this.props.id, response.data.dropDistancePoint));
                            this.props.dispatch(setFocusPoints(this.props.id, response.data.focusPoints));
                            this.setState({
                                scanSettingsType: key,
                                scanPathSet: true,
                                currResponse: response,
                            });
                        } else {
                            this.props.dispatch(receivedPreviewStatus(ScanApiConstant.ERRORED_WHILE_CONFIRMING_SELECTION, response, this.props.id));
                            message.error("Not able to switch to advanced settings. Please contact admin.", 2.5);
                        }
                        this.props.dispatch(setDeviceIdle(this.props.device_id));
                        this.props.dispatch(updateActionOngoing(this.props.id, false, scanWorkflowLoadingMessages.EMPTY_MESSAGE));
                    })
                    .catch(err => {
                        this.props.dispatch(receivedPreviewStatus(ScanApiConstant.ERRORED_WHILE_CONFIRMING_SELECTION, err, this.props.id))
                        this.props.dispatch(setDeviceIdle(this.props.device_id));
                        this.props.dispatch(updateActionOngoing(this.props.id, false, scanWorkflowLoadingMessages.EMPTY_MESSAGE));
                        message.error("Not able to switch to advanced settings. Please contact admin.", 2.5);
                    })
            } else {
                this.setState({
                    scanSettingsType: key,
                });
            }
        } else if (key == scanSettingsTypeVals.GENERAL) {
            this.setState({
                scanSettingsType: key,
            });
        }
    }

    render() {
        let status = (this.props.preview || {}).status;
        let allowPainting = false;
        let slotComp = null;

        if (this.state.brushType != brushType.REDRAW) {
            allowPainting = true;
        }

        if (this.props.showSummary) {
            slotComp = this.props.summaryDiv;
        } else if (this.props.id === -1 || status === RegionSelectionConstants.NOT_STARTED) {
        } else if (status !== RegionSelectionConstants.ERRORED_OUT) {
            slotComp = (
                <div className="relative-parent properties-width">
                    <Tabs className="tab-section-height" activeKey={this.state.scanSettingsType}
                          onChange={this.changeScanSettingsType}>
                        <TabPane tab="General" key={scanSettingsTypeVals.GENERAL}>
                            <GeneralPreviewSettingsComp showBrushOrEraserSize={this.showBrushOrEraserSize}
                                                        brushType={this.state.brushType}
                                                        brushSize={this.state.brushSize}
                                                        changeBrushType={this.changeBrushType}
                                                        movedBrushSizeSlider={this.movedBrushSizeSlider} status={status}
                                                        previewCanvasRef={this.previewCanvasRef}
                                                        thresholdCanvasRef={this.thresholdCanvasRef}
                                                        brushEraserPrevCanvasRef={this.brushEraserPrevCanvasRef}
                                                        regions={this.state.regions}
                                                        onCanvasUpdate={this.onCanvasUpdate}
                                                        allowPainting={allowPainting} startPainting={this.startPainting}
                                                        paintCanvas={this.paintCanvas}
                                                        stopPainting={this.stopPainting}
                                                        dropDistanceCanvas={this.dropDistanceCanvas}
                                                        dropDistanceCanvasRef={this.dropDistanceCanvasRef}
                                                        focusPointsCanvas={this.focusPointsCanvas}
                                                        focusPointsCanvasRef={this.focusPointsCanvasRef}
                                                        id={this.props.id} device_id={this.props.device_id}
                                                        onScanNameChange={this.onScanNameChange}
                                                        readbarcode={this.readbarcode}
                                                        reading_barcode={this.state.reading_barcode}
                                                        onSpecimenTypeChange={this.onSpecimenTypeChange}
                                                        onScanSpeedChange={this.onScanSpeedChange}
                                                        onScanSpeedChangeStack={this.onScanSpeedChangeStack}
                                                        onZLevelsChange={this.onZLevelsChange}
                                                        onStepSizeChange={this.onStepSizeChange}
                                                        toggleTiling={this.toggleTiling}
                                                        toggleTilingAfterScan={this.toggleTilingAfterScan}
                                                        regionArea={this.state.regionArea}
                                                        autoExport={this.state.autoExport} toggleExporting={this.toggleExporting}
                                                        onAutoThreshLevelChange={this.onAutoThreshLevelChange}
                                                        brushShape={this.state.brushShape}
                                                        changeBrushShape={this.changeBrushShape}
                            />
                        </TabPane>
                        <TabPane tab="Advanced" key={scanSettingsTypeVals.ADVANCED}
                                 disabled={(((this.props.deviceStatus[this.props.device_id] || {}).scanner_health || {}).scanner_response || {}).busy}
                        >
                            <AdvancedPreviewSettingsComp
                                id={this.props.id} device_id={this.props.device_id}
                                scanSettingsType={this.state.scanSettingsType}
                                currResponse={this.state.currResponse}
                            />
                        </TabPane>
                    </Tabs>
                    <Row className="save-button-height">
                        <Col offset={0} span={24}>
                            <Button style={{width: '40%', marginLeft: '30%', marginRight: '30%'}} type="primary"
                                    onClick={this.confirmPreviewSettingChanges} className={"black-scanner-btn"}>
                                Finalize slide setting
                            </Button>
                        </Col>
                    </Row>
                </div>
            )
        } else {
            slotComp = <Row>Error</Row>;
        }

		return (
			<Spin indicator={antdSpinLoaderSmallIcon} style={{color: '#000'}} tip={this.props.preview.message}
                  spinning={this.props.preview.status === RegionSelectionConstants.GETTING_IMAGE || this.props.preview.actionOngoing}>
				{slotComp}
			</Spin>
		);
	}
}

const mapStateToProps = (state, ownProps) => {
    let {displaySettings, displaySettingsList} = state.gammaStateReducer
    return {
        preview: state.previewStatusReducer[ownProps.id],
        deviceStatus: state.deviceStatusReducer,
        slot_id: ownProps.slot_id,
        bloodConfig: state.bloodConfigReducer,
        displaySettingsList,
        displaySettings
    };
};

export default connect(mapStateToProps)(SlotComponent);
